function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import camelcaseKeys from 'camelcase-keys';
import { createMessage } from "../core/createMessage.mjs";
import { isWebView } from "../core/isWebView.mjs";
import { thenable } from "../core/thenable.mjs";
import { Type } from "../protocol/Type.mjs";
import { PluginBase } from "./Base.mjs";
export class PluginInfo extends PluginBase {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "namespace", 'info');
  }

  async app() {
    var _message$payload, _message$payload$info;

    if (!isWebView()) {
      this.logger.log('WARN', 'bridge.info.app', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
      return null;
    }

    const message = await thenable(this.driver).postMessage(createMessage({
      type: Type.ReqInfoApp
    }));

    if (!((_message$payload = message.payload) !== null && _message$payload !== void 0 && (_message$payload$info = _message$payload.info) !== null && _message$payload$info !== void 0 && _message$payload$info.app)) {
      return null;
    } else {
      return camelcaseKeys(message.payload.info.app);
    }
  }

  async region() {
    var _message$payload2, _message$payload2$inf;

    if (!isWebView()) {
      this.logger.log('WARN', 'bridge.info.region', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
      return null;
    }

    const message = await thenable(this.driver).postMessage(createMessage({
      type: Type.ReqInfoRegion
    }));

    if (!((_message$payload2 = message.payload) !== null && _message$payload2 !== void 0 && (_message$payload2$inf = _message$payload2.info) !== null && _message$payload2$inf !== void 0 && _message$payload2$inf.region)) {
      return null;
    } else {
      return camelcaseKeys(message.payload.info.region);
    }
  }

  async location() {
    var _message$payload3, _message$payload3$inf;

    if (!isWebView()) {
      this.logger.log('WARN', 'bridge.info.location', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
      return null;
    }

    const message = await thenable(this.driver).postMessage(createMessage({
      type: Type.ReqInfoLocation
    }));

    if (!((_message$payload3 = message.payload) !== null && _message$payload3 !== void 0 && (_message$payload3$inf = _message$payload3.info) !== null && _message$payload3$inf !== void 0 && _message$payload3$inf.location)) {
      return null;
    } else {
      return camelcaseKeys(message.payload.info.location);
    }
  }

  async user() {
    var _message$payload4, _message$payload4$inf;

    if (!isWebView()) {
      this.logger.log('WARN', 'bridge.info.user', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
      return null;
    }

    const message = await thenable(this.driver).postMessage(createMessage({
      type: Type.ReqInfoUser
    }));

    if (!((_message$payload4 = message.payload) !== null && _message$payload4 !== void 0 && (_message$payload4$inf = _message$payload4.info) !== null && _message$payload4$inf !== void 0 && _message$payload4$inf.user)) {
      return null;
    } else {
      return camelcaseKeys(message.payload.info.user);
    }
  }

  async regionName() {
    var _message$payload5, _message$payload5$inf;

    if (!isWebView()) {
      this.logger.log('WARN', 'bridge.info.regionName', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
      return null;
    }

    const message = await thenable(this.driver).postMessage(createMessage({
      type: Type.ReqInfoRegionName
    }));

    if (!((_message$payload5 = message.payload) !== null && _message$payload5 !== void 0 && (_message$payload5$inf = _message$payload5.info) !== null && _message$payload5$inf !== void 0 && _message$payload5$inf.regionName)) {
      return null;
    } else {
      return camelcaseKeys(message.payload.info.regionName);
    }
  }

}